import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css'
import './index.css'
import shot_gun from './assets/shot_gun.svg'
import { useEffect, useState } from 'react';
import audi  from './assets/shotgun2.mp3'
import { Route, Routes, useLocation } from 'react-router-dom';
import Dashboard from './Dashboard/Dashboard';
import OpenNews from './Dashboard/OpenNews';
import Footer from './Dashboard/Footer';
import NavbarB from './Dashboard/NavbarB';
import GalleryImages from './Dashboard/GalleryImages';

const audioElement1 = new Audio(audi);

export default function App() {
  const [cursor, setcursor]=useState([])
  const location = useLocation();

  const hasClass = (node, className) => typeof node?.className === "string" && node.className.indexOf(className) !== -1;

  const changeMouse=(e)=>{
    const target = e.target;
    const parent = target?.parentElement;
    const grandParent = parent?.parentElement;
    const fourthParent = grandParent?.parentElement?.parentElement;

    if(target?.tagName!=="svg" && target?.tagName!=="path"){
      const shouldSkip =
        parent?.className==="til" ||
        hasClass(target,"navbar-toggler") ||
        hasClass(parent,"navbar-toggler") ||
        hasClass(parent,"ymaps") ||
        hasClass(parent,"btnGreen") ||
        target?.className==="poligons_item" ||
        parent?.className==="membersInput" ||
        target?.className==="btn_img" ||
        hasClass(target,"pag_item") ||
        parent?.className==="navbar-brand" ||
        hasClass(fourthParent,"ant-carousel") ||
        hasClass(fourthParent,"slick-track") ||
        grandParent?.className==="faq_box" ||
        grandParent?.className==="faq_questions" ||
        grandParent?.className==="faq" ||
        parent?.className==="brand_text" ||
        grandParent?.className==="brand_text" ||
        target?.className==="navbar-brand" ||
        target?.tagName==="A" ||
        parent?.tagName==="A" ||
        grandParent?.tagName==="A" ||
        target?.className==="ymaps-2-1-79-events-pane ymaps-2-1-79-user-selection-none" ||
        hasClass(grandParent,"modal") ||
        hasClass(parent,"modal");

      if(!shouldSkip){
        let x = e.clientX;
        let y = e.clientY+window.scrollY;
        const con={opacity:1, zIndex:'4455', top:y-20,left:x-20};

        setcursor((prev) => {
          const next = [...prev, con];
          remove_shot(next.length - 1);
          return next;
        });

        audioElement1.pause();
        audioElement1.currentTime = 0;
        audioElement1.play().catch(() => {});
      }
    }
  }

  const remove_shot=(key)=>{
    setTimeout(() => {
      setcursor((prev) => prev.map((item, index) => (
        index === key ? { ...item, opacity: 0, zIndex: '-4566' } : item
      )));
    }, 2000);
  }

  useEffect(()=>{
    if(location.pathname === '/fotoalbom' || location.pathname.indexOf('/allnews') !== -1){
      window.scrollTo(0, 0);
    }
  },[location])

  return (
    <div className='big_boss' onClick={changeMouse}>
      <Routes>
        <Route path="/" element={<Dashboard/>}/>
        <Route path="/allnews/:id" element={<>
        <NavbarB id="n"/>
        <OpenNews/>
        <Footer/>
        </>}/>
        <Route path="/fotoalbom" element={<>
        <NavbarB id="g"/>
        <GalleryImages/>
        <Footer/>
        </>}/>
      </Routes>

      {cursor.map((item, key)=>(
        <img
          key={key}
          style={{opacity: item.opacity,zIndex: item.zIndex,top:item.top,  left:item.left}}
          className='shot_gun'
          src={shot_gun}
          alt=""
        />
      ))}
    </div>
  )
}
